import { ICreateEspecificidadeObraUseCase } from "../../../presentation/useCases/create/create_especificidade_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateEspecificidadeObraUseCase
 */

export class CreateEspecificidadeObraUseCase implements ICreateEspecificidadeObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createEspecificidadeObra(
    idObra: number,
    item: string,
    formaControle: string,
  ): Promise<void> {
    await this.repository.createEspecificidadeObra(
      idObra,
      item,
      formaControle,
    );
  }
}
